import { Route } from 'react-router-dom';

import ServiceAreaPage from 'pages/unitoverview/sectionPages/ServiceAreaPage';
import HealthChecksSectionPage from 'pages/unitoverview/sectionPages/Services/HealthChecksSectionPage';
import ServiceAgreementsSectionPage from 'pages/unitoverview/sectionPages/Services/ServiceAgreementsSectionPage';
import ServiceProtocolsPage from 'pages/unitoverview/sectionPages/Services/ServiceProtocolsPage';
import UnitRepairsSectionPage from 'pages/unitoverview/sectionPages/Services/UnitRepairsSectionPage';

import { PageRedirect } from './PageRedirect';
import {
	UnitOverview_ServiceArea,
	UnitOverview_Services_HealthChecks,
	UnitOverview_Services_Repairs,
	UnitOverview_Services_ServiceAgreements,
	UnitOverview_Services_ServiceProtocols,
} from './urls/RouteUrls';

export const getUnitServicesAreaRoutes = (): React.JSX.Element[] => [
	<Route key={UnitOverview_ServiceArea} element={<ServiceAreaPage />}>
		<Route
			index
			element={
				<PageRedirect url={UnitOverview_Services_ServiceProtocols} />
			}
		/>

		<Route
			path={UnitOverview_Services_ServiceAgreements}
			element={<ServiceAgreementsSectionPage />}
		/>
		<Route
			path={UnitOverview_Services_ServiceProtocols}
			element={<ServiceProtocolsPage />}
		/>
		<Route
			path={UnitOverview_Services_HealthChecks}
			element={<HealthChecksSectionPage />}
		/>
		<Route
			path={UnitOverview_Services_Repairs}
			element={<UnitRepairsSectionPage />}
		/>
	</Route>,
];
